import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-card" }
const _hoisted_2 = { class: "avatar" }
const _hoisted_3 = { class: "avatar-initials" }
const _hoisted_4 = { class: "profile-name" }
const _hoisted_5 = { class: "profile-username" }
const _hoisted_6 = { class: "profile-badges" }
const _hoisted_7 = { class: "profile-details" }
const _hoisted_8 = { class: "detail-row" }
const _hoisted_9 = { class: "detail-icon" }
const _hoisted_10 = { class: "detail-content" }
const _hoisted_11 = { class: "detail-value" }
const _hoisted_12 = { class: "detail-row" }
const _hoisted_13 = { class: "detail-icon" }
const _hoisted_14 = { class: "detail-content" }
const _hoisted_15 = { class: "detail-value" }
const _hoisted_16 = { class: "detail-row" }
const _hoisted_17 = { class: "detail-icon" }
const _hoisted_18 = { class: "detail-content" }
const _hoisted_19 = { class: "detail-value" }
const _hoisted_20 = { class: "detail-row" }
const _hoisted_21 = { class: "detail-icon" }
const _hoisted_22 = { class: "detail-content" }
const _hoisted_23 = { class: "detail-value" }
const _hoisted_24 = { class: "profile-actions" }
const _hoisted_25 = { class: "edit-btn" }
const _hoisted_26 = { class: "delete-btn" }

import type { User } from "@/types/user";
import BaseIcon from "@/components/ui/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfileCard',
  props: {
    user: {}
  },
  setup(__props: any) {

const props = __props;

const initials = props.user.fullName
  .split(" ")
  .map((n) => n[0])
  .join("")
  .toUpperCase()
  .slice(0, 2);

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(initials)), 1)
    ]),
    _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.user.fullName), 1),
    _createElementVNode("span", _hoisted_5, "@" + _toDisplayString(__props.user.username), 1),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", {
        class: _normalizeClass(['badge', __props.user.isActive ? 'badge--green' : 'badge--red'])
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "badge-dot" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(__props.user.isActive ? "Active" : "Inactive"), 1)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(['badge', __props.user.isLoggedIn ? 'badge--cyan' : 'badge--muted'])
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "badge-dot" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(__props.user.isLoggedIn ? "Logged In" : "Offline"), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(BaseIcon, {
            name: "list",
            size: 14
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "detail-label" }, "User ID", -1)),
          _createElementVNode("span", _hoisted_11, _toDisplayString(__props.user.id), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(BaseIcon, {
            name: "mail",
            size: 14
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "detail-label" }, "Email", -1)),
          _createElementVNode("span", _hoisted_15, _toDisplayString(__props.user.email), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(BaseIcon, {
            name: "calendar",
            size: 14
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "detail-label" }, "Created At", -1)),
          _createElementVNode("span", _hoisted_19, _toDisplayString(formatDate(__props.user.createdAt)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(BaseIcon, {
            name: "shield",
            size: 14
          })
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "detail-label" }, "Role", -1)),
          _createElementVNode("span", _hoisted_23, _toDisplayString(__props.user.role), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("button", _hoisted_25, [
        _createVNode(BaseIcon, {
          name: "edit",
          size: 13
        }),
        _cache[6] || (_cache[6] = _createTextVNode(" Edit User ", -1))
      ]),
      _createElementVNode("button", _hoisted_26, [
        _createVNode(BaseIcon, {
          name: "trash",
          size: 13
        })
      ])
    ])
  ]))
}
}

})